import { createFeatureSelector, createSelector } from '@ngrx/store'
import * as reducer from './template.reducer'
import * as state from './template.state'
import { Template, TemplateType } from './template.model'
import * as R from 'ramda'

export const templateState = createFeatureSelector<state.State>('template-lib')

export const selectAllTemplates = createSelector(templateState, reducer.selectAll)

export const selectTemplateEntities = createSelector(templateState, reducer.selectEntities)

export const selectTemplatesLoaded = createSelector(templateState, (state: state.State) => state.isLoaded)

export const selectAllMessageTemplates = createSelector(selectAllTemplates, (templates) => {
  return R.filter(
    (t: Template) =>
      ![TemplateType.Contract, TemplateType.CustomBranding, TemplateType.InvoiceTemplate].includes(t.type)
  )(templates)
})

export const selectAllBrandingTemplates = createSelector(selectAllTemplates, (templates) => {
  return R.filter((t: Template) => TemplateType.CustomBranding == t.type)(templates)
})

export const selectTemplatesByTypes = createSelector(selectAllTemplates, (templates, props) => {
  return R.filter((t: Template) => R.contains(t.type, props.types))(templates)
})

export const isUpdatingTemplates = createSelector(templateState, (state) => state.isUpdating)

export const lastAddedTemplateId = createSelector(templateState, (state) => state.lastAddedId)

export const lastEditedTemplateId = createSelector(templateState, (state) => state.lastEditedId)

export const selectLastAddedTemplate = createSelector(
  templateState,
  selectTemplateEntities,
  (state, entities: { [id: string]: Template }) => entities[state.lastAddedId]
)

export const selectLastEditedTemplate = createSelector(
  templateState,
  selectTemplateEntities,
  (state, entities: { [id: string]: Template }) => entities[state.lastEditedId]
)

export const selectTemplateForTriggerByEvent = (event: string) =>
  createSelector(selectAllMessageTemplates, (templates) => {
    return R.find((t) => t.event === event, templates)
  })

export const selectTemplateById = (id: string) =>
  createSelector(templateState, (state: state.State) => state.entities[id])
